import React from "react";
import { motion } from "framer-motion";
import { GraduationCap, Award, BookOpen } from "lucide-react";

const WhyChoose: React.FC = () => {
  const features = [
    {
      icon: GraduationCap,
      title: "Cambridge Faculty",
      description:
        "Learn directly from Cambridge University professors and certified instructors with decades of academic experience.",
    },
    {
      icon: Award,
      title: "Official Certification",
      description:
        "Earn recognized Cambridge certificates that enhance your academic profile and university applications.",
    },
    {
      icon: BookOpen,
      title: "Rigorous Curriculum",
      description:
        "Experience the same academic rigor and excellence that Cambridge students receive in their coursework.",
    },
  ];

  return (
    <motion.section
      id="why-choose"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="py-16 bg-gray-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Choose Our Research Programmes?
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Experience authentic Cambridge education with official certification
            and world-class faculty guidance.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-blue-600 rounded-xl flex items-center justify-center mb-6">
                <feature.icon className="h-6 w-6 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </motion.section>
  );
};

export default WhyChoose;
